/* ============================================================
   ctr-testimonials — reviews carousel (Swiper) with external
   prev/next controls. Cards per view (desktop) comes from the
   data-per-view attribute set by section settings.
   ============================================================ */

(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.ctrTstInit) return;
    root.dataset.ctrTstInit = 'true';

    var sliderEl = root.querySelector('.ctr-testimonials__slider');
    if (!sliderEl || !window.Swiper) return;

    var perView = parseInt(root.dataset.perView, 10) || 4;

    new Swiper(sliderEl, {
      loop: true,
      spaceBetween: 24,
      slidesPerView: 1.05,
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: perView }
      },
      navigation: {
        prevEl: root.querySelector('[data-ctr-prev]'),
        nextEl: root.querySelector('[data-ctr-next]')
      }
    });
  }

  function initAllSections() {
    document.querySelectorAll('[data-ctr-testimonials]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', initAllSections);
})();
